import { CompanyActionTypes } from './types';
import { CompanyStateI, companyInitialState } from './state';

export const companyReducer = (state = companyInitialState, action: any): CompanyStateI => {
  switch (action.type) {
    case CompanyActionTypes.LOAD_STATE:
      return {
        ...state,
        ...action.payload, // Merge stored state with initial state
      };
    case CompanyActionTypes.SET_LOCATIONS:
      return {
        ...state,
        locations: action.payload,
      };
    case CompanyActionTypes.SET_USERS:
      return {
        ...state,
        users: action.payload,
      };
    case CompanyActionTypes.SET_CLIENTS:
      return {
        ...state,
        clients: action.payload,
      };
    case CompanyActionTypes.SET_RATINGS:
      return {
        ...state,
        ratings: action.payload,
      };
    case CompanyActionTypes.SET_CAREPARTNERS:
      return {
        ...state,
        carePartners: action.payload,
      };
    case CompanyActionTypes.SET_CARE_MANAGER_ACTIVITIES:
      return {
        ...state,
        careManagerActivities: action.payload,
      };
    case CompanyActionTypes.SET_APPLICANTS:
      return {
        ...state,
        applicants: action.payload,
      };
    case CompanyActionTypes.SET_AWARD_TYPES:
      return {
        ...state,
        awardTypes: action.payload,
      };
    case CompanyActionTypes.SET_DEACTIVATION_REASONS:
      return {
        ...state,
        deactivationReasons: action.payload,
      };
    case CompanyActionTypes.SET_LOST_CLIENT_REASONS:
      return {
        ...state,
        lostClientReasons: action.payload,
      };
    case CompanyActionTypes.SET_PROSPECT_LOST_CLIENT_REASON:
      return {
        ...state,
        prospectlostClientReason: action.payload,
      };
    case CompanyActionTypes.SET_APPLICANT_STAGES:
      return {
        ...state,
        applicantStages: action.payload,
      };
    case CompanyActionTypes.SET_REFERRAL_PARTNERS:
      return {
        ...state,
        referralPartner: action.payload,
      };
    case CompanyActionTypes.RESET:
      return { ...companyInitialState };
    case CompanyActionTypes.SET_COMPANIES:
      return {
        ...state,
        companies: action.payload,
      };
    case CompanyActionTypes.SET_PROSPECT:
      return {
        ...state,
        prospect: action.payload,
      };
    case CompanyActionTypes.SET_COMPANY_RATINGS:
      return {
        ...state,
        companyRatings: action.payload,
      };
    case CompanyActionTypes.SET_PRIORITY_INDEXES:
      return {
        ...state,
        priorityIndexes: action.payload,
      };
    case CompanyActionTypes.SET_PRIORITY_INDEXES_CP:
      return {
        ...state,
        priorityIndexesCP: action.payload,
      };
    case CompanyActionTypes.SET_MILESTONES:
      return {
        ...state,
        milestones: action.payload,
      };

    case CompanyActionTypes.SET_ACTIVITY_TYPES:
      return {
        ...state,
        activityTypes: action.payload,
      };
    case CompanyActionTypes.SET_APPLICANT_ACTIVITY:
      return {
        ...state,
        applicantsActivity: action.payload,
      };
    case CompanyActionTypes.SET_APPLICANT_SOURCES:
      return {
        ...state,
        applicantSources: action.payload,
      };
    case CompanyActionTypes.SET_COMPANY_TYPES:
      return {
        ...state,
        companyTypes: action.payload,
      };
    case CompanyActionTypes.SET_LEAD_SOURCES:
      return {
        ...state,
        leadSources: action.payload,
      };
    case CompanyActionTypes.SET_REFERRAL_ACTIVITY_TYPES:
      return {
        ...state,
        referralActivityTypes: action.payload,
      };
    case CompanyActionTypes.SET_APPLICANT_ACTIVITY_TYPE_CATEGORY:
      return {
        ...state,
        applicantActivityTypeCategory: action.payload,
      };
    case CompanyActionTypes.SET_ACTIVITY_CATEGORY_MANAGEMENT:
      return {
        ...state,
        activityCategoryManagement: action.payload,
      };
    case CompanyActionTypes.SET_PROSPECT_ACTIVITY_CATEGORY:
      return {
        ...state,
        prospectActivityCategory: action.payload,
      };
    case CompanyActionTypes.SET_REFERRAL_PARTNERS_ACTIVITY_CATEGORY:
      return {
        ...state,
        referralPartnersActivityCategory: action.payload,
      };
    case CompanyActionTypes.SET_AUTHORIZATION_STAGES:
      return {
        ...state,
        authorizationStages: action.payload,
      };
    case CompanyActionTypes.SET_REAUTHORIZATION_STAGES:
      return {
        ...state,
        reAuthorizationStages: action.payload,
      };
    case CompanyActionTypes.SET_AUTHORIZATION_TYPES:
      return {
        ...state,
        authorizationTypes: action.payload,
      };
    case CompanyActionTypes.SET_AUTHORIZATIONS:
      return {
        ...state,
        authorizations: action.payload,
      };
    case CompanyActionTypes.SET_REQUESTED_STAGES:
      return {
        ...state,
        requestedStages: action.payload,
      };
    case CompanyActionTypes.SET_TAGS:
      return {
        ...state,
        tags: action.payload,
      };
    case CompanyActionTypes.SET_TAG_CATEGORY:
      return {
        ...state,
        tagCategory: action.payload,
      };
    case CompanyActionTypes.SET_PROSPECT_STAGES:
      return {
        ...state,
        prospectStages: action.payload,
      };
    case CompanyActionTypes.SET_CONTACT_TYPES:
      return {
        ...state,
        contactTypes: action.payload,
      };
    case CompanyActionTypes.SET_CONTACT_RELATIONSHIPS:
      return {
        ...state,
        contactRelationships: action.payload,
      };
    case CompanyActionTypes.SET_DISCIPLINARY_STEPS:
      return {
        ...state,
        disciplinarySteps: action.payload,
      };
    case CompanyActionTypes.SET_DISCIPLINARY_CATEGORIES:
      return {
        ...state,
        disciplinaryCategories: action.payload,
      };
    case CompanyActionTypes.SET_DISCIPLINARY_ACKS:
      return {
        ...state,
        disciplinaryAcks: action.payload,
      };
    case CompanyActionTypes.SET_DISCIPLINARY_ATTENDANCE_TYPES:
      return {
        ...state,
        disciplinaryAttendanceTypes: action.payload,
      };
    case CompanyActionTypes.SET_APPLICANT_THRESHOLD:
      return {
        ...state,
        applicantThreshold: action.payload,
      };
    default:
      return state;
  }
};
